module.exports = __webpack_public_path__ + "img/creative.c2b9f928.png";